
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Paper,
  Box,
  Typography,
  IconButton,
  Input,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
  Avatar
} from '@mui/material';
import { DateTimePicker, TimePicker } from '@mui/x-date-pickers';
import { Delete, AddAPhoto, AttachFile } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers';
import { toInteger } from 'lodash';

const EditCampaignDialog = ({ campaign, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    message_header: '',
    message_text: '',
    images: [],
    files: [],
    filters: {
      start: '',
      end: '',
      repeat: '',
      unit: 'seconds',
      timeSlot: '',
      dayFilter: [],
      monthdate: '',
      daterange: []
    }
  });
  // const [monthDateFilter,setMonthDateFilter] = useState(false);

  useEffect(() => {
    const parsedFilters = campaign.filters ? JSON.parse(campaign.filters) : {};
    const formattedFilters = {
      start: parsedFilters.start || '',
      end: parsedFilters.end || '',
      repeat: parsedFilters.repeat ? parsedFilters.repeat.value : '',
      unit: parsedFilters.repeat ? parsedFilters.repeat.unit : 'seconds',
      timeSlot: parsedFilters.timeSlot || '',
      dayFilter: parsedFilters.dayFilter || [],
      monthdate : parsedFilters.monthdate,
      daterange: []
      
    };

    setFormData({
      message_header: campaign.message_header || '',
      message_text: campaign.message_text || '',
      fileType: campaign.lol,
      images: campaign.file_type === "photo" ? [campaign.number_of_files] : [],
      files: campaign.file_type === "file" ? campaign.number_of_files : [],
      filters: formattedFilters

    });
  }, [campaign]);

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setFormData(prev => ({
      ...prev,
      images: [...prev.images, ...files.map(f => URL.createObjectURL(f))]
    }));
  };

  const handleRemoveImage = (index) => {
    setFormData(prev => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index)
    }));
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    setFormData(prev => ({
      ...prev,
      files: [...prev.files, ...files.map(f => f.name)]
    }));
  };

  const handleRemoveFile = (index) => {
    setFormData(prev => ({
      ...prev,
      files: prev.files.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = () => {
    const filters = {
      start: formData.filters.start,
      end: formData.filters.end,
      repeat: { value: parseInt(formData.filters.repeat), unit: formData.filters.unit.toString() },
      timeSlot: formData.filters.timeSlot == null ? "" : formData.filters.timeSlot,
      dayFilter: formData.filters.dayFilter,
      monthdate: formData.filters.monthdate,
      daterange:[]
    };

    if (filters.repeat.unit === "hours" || filters.repeat.unit === "minutes" || filters.repeat.unit === "seconds"){
      filters.dayFilter = []
    }

    const updatedCampaign = {
      ...campaign,
      message_header: formData.message_header,
      message_text: formData.message_text,
      images: formData.images,
      files: formData.files,
      filters: JSON.stringify(filters)
    };
    // console.log(updatedCampaign)
    onSave(updatedCampaign);
  };

  const disableTimeAndDayFilter = ['seconds', 'minutes', 'hours'].includes(formData.filters.unit);
  const monthDateFilter = !['months'].includes(formData.filters.unit);

  return (
    <Dialog open  fullWidth style={{}} maxWidth="md" onClose={onClose}>
      <DialogTitle>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Edit Campaign</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ p: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Header"
                variant="outlined"
                value={formData.message_header}
                onChange={(e) => setFormData(prev => ({ ...prev, message_header: e.target.value }))}
                sx={{ mb: 2 }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth
                multiline
                rows={4}
                label="Message"
                variant="outlined"
                value={formData.message_text}
                onChange={(e) => setFormData(prev => ({ ...prev, message_text: e.target.value }))}
                sx={{ mb: 2 }}
              />
            </Grid>

            {formData.fileType === "photo" && (
              <Grid item xs={12} md={6}>
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Grid item xs={12}>
                    <Input
                      type="file"
                      inputProps={{ multiple: true }}
                      onChange={handleImageUpload}
                      style={{ display: 'none' }}
                      id="image-upload"
                    />
                    <label htmlFor="image-upload">
                      <Button variant="outlined" component="span" startIcon={<AddAPhoto />}>
                        Add Images
                      </Button>
                    </label>
                    <div style={{ marginTop: 16 }}>
                      {formData.images.map((file, index) => (
                        <Chip
                          key={index}
                          avatar={<Avatar src={"http://localhost:5000/api/files/download/" + file} />}
                          label={file}
                          onDelete={() => handleRemoveImage(index)}
                          sx={{ marginRight: 1, marginBottom: 1 }}
                        />
                      ))}
                    </div>
                  </Grid>
                </Paper>
              </Grid>
            )}

            {formData.fileType === "file" && (
              <Grid item xs={12} md={6}>
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <label htmlFor="file-upload">
                      <Input
                        type="file"
                        inputProps={{ multiple: true }}
                        onChange={handleFileUpload}
                        style={{ display: 'none' }}
                        id="file-upload"
                      />
                      <Button variant="outlined" component="span" startIcon={<AttachFile />}>
                        Add Files
                      </Button>
                    </label>
                  </Box>
                  <Box sx={{ mt: 2 }}>
                    {formData.files.length > 0 ? (
                      <Grid container spacing={2}>
                        {formData.files.map((file, index) => (
                          <Grid item xs={12} key={index}>
                            <Paper
                              variant="outlined"
                              sx={{ p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <AttachFile sx={{ mr: 1 }} />
                                <Typography variant="body2">{file}</Typography>
                              </Box>
                              <IconButton size="small" onClick={() => handleRemoveFile(index)}>
                                <Delete fontSize="small" />
                              </IconButton>
                            </Paper>
                          </Grid>
                        ))}
                      </Grid>
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        No files uploaded.
                      </Typography>
                    )}
                  </Box>
                </Paper>
              </Grid>
            )}

            <Grid item xs={12}>
              <Paper variant="outlined" sx={{ p: 2 }}>
                <Typography variant="subtitle1" gutterBottom>
                  Schedule Details
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Start Date"
                      value={formData.filters.start ? formData.filters.start : null}
                      type="date"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      onChange={(date) =>
                        setFormData(prev => ({
                          ...prev,
                          filters: { ...prev.filters, start: date ? date : '' }
                        }))
                      }
                      // renderInput={(params) => <TextField {...params} fullWidth variant="outlined" />}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="End Date"
                      type="date"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      value={formData.filters.end ? formData.filters.end : null}
                      
                      onChange={(date) =>
                        setFormData(prev => ({
                          ...prev,
                          filters: { ...prev.filters, end: date ? date : '' }
                        }))
                      }
                      // renderInput={(params) => <TextField {...params} fullWidth variant="outlined" />}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Repeat"
                      type="number"
                      variant="outlined"
                      value={formData.filters.repeat}
                      onChange={(e) =>
                        setFormData(prev => ({
                          ...prev,
                          filters: { ...prev.filters, repeat: e.target.value }
                        }))
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel id="unit-label">Unit</InputLabel>
                      <Select
                        labelId="unit-label"
                        label="Unit"
                        value={formData.filters.unit}
                        onChange={(e) =>
                          setFormData(prev => ({
                            ...prev,
                            filters: { ...prev.filters, unit: e.target.value }
                          }))
                        }

                        
                      >
                        <MenuItem value="seconds">Seconds</MenuItem>
                        <MenuItem value="minutes">Minutes</MenuItem>
                        <MenuItem value="hours">Hours</MenuItem>
                        <MenuItem value="days">Days</MenuItem>
                        <MenuItem value="weeks">(Int) by Weeks</MenuItem>
                        <MenuItem value="months">(Int) by Months</MenuItem>
                        {/* <MenuItem value="years">Years</MenuItem> */}
                      </Select>

                      <TextField
                      disabled={monthDateFilter}
                      label="Date"
                      select
                      
                      value={formData.filters.monthdate}
                      onChange={(e) =>
                        setFormData(prev => ({
                          ...prev,
                          filters: { ...prev.filters, monthdate: e.target.value }
                        }))}
                      
                      fullWidth
                    >
                      
                      {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                        <MenuItem key={day} value={day}>
                          {day}
                        </MenuItem>
                      ))}
                    </TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TimePicker
                      label="Time Slot"
                      disabled={disableTimeAndDayFilter}
                      value={
                        new Date(formData.filters.timeSlot)
                      }
                      timezone="UTC"
                      onChange={(time)=>{formData.filters.timeSlot = time}}
                      renderInput={(params) => <TextField {...params} fullWidth variant="outlined" />}
                    />
                    
                
                    
                        
                      
                      
                    
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel id="dayfilter-label">Day Filter</InputLabel>
                      <Select
                        labelId="dayfilter-label"
                        label="Day Filter"
                        multiple
                        disabled={disableTimeAndDayFilter}
                        value={formData.filters.dayFilter}
                        onChange={(e) =>
                          setFormData(prev => ({
                            ...prev,
                            filters: { ...prev.filters, dayFilter: e.target.value }
                          }))
                        }
                        renderValue={(selected) => selected.join(', ')}
                      >
                        {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day) => (
                          <MenuItem key={day} value={day}>
                            <Checkbox checked={formData.filters.dayFilter.indexOf(day) > -1} />
                            <ListItemText primary={day} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" sx={{ color: 'gray' }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCampaignDialog;